import { TaskStatus, WaitingOnReason } from 'modules/common/components/MemberOperator/MemberOperator.interfaces';
import collectiveApi from 'modules/common/collectiveApi';

export default async function updateOperatorTaskStatus(
    id: string,
    status: TaskStatus,
    execute_handlers_async?: boolean,
    completion_payload?: Record<string, any> | undefined,
    waiting_on?: WaitingOnReason
) {
    const { status: responseStatus } = await collectiveApi.post(`/v2/members/tasks/${id}/status/`, {
        status,
        execute_handlers_async,
        completion_payload,
        waiting_on,
    });
    return responseStatus;
}
